import { Apis } from "libs/apis";
import { dispatch } from "store";
import { setModalClosed } from "store/user-slice";

export const useOnBoarding = () => {
  const getOnBoarding = async (setData: any) => {
    await Apis.getOnBoarding()
      .then((res) => {
        setData(res.data.formattedOnBoardings);
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const getOnBoardingById = async (id: number, setData: any) => {
    await Apis.getOnBoardingById(id)
      .then((res) => {
        setData(res.data.onBoarding);
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const postOnBoarding = async (body: any) => {
    const res = await Apis.postOnBoarding(body);
    if (res.data.status) {
      dispatch(setModalClosed("OnBoarding Screen"));
    }
    return res;
  };

  const putOnBoarding = async (id: number, body: FormData) => {
    const res = await Apis.putOnBoarding(id, body);
    if (res.data.status) {
      dispatch(setModalClosed("OnBoarding Screen"));
    }
    return res;
  };
  const uploadOnBoardingImage = async (body: any, setSelectedImage: any) => {
    await Apis.uploadOnBoardingImage(body)
      .then((res) => {
        setSelectedImage(res.data.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };
  return {
    getOnBoarding,
    postOnBoarding,
    putOnBoarding,
    uploadOnBoardingImage,
    getOnBoardingById,
  };
};
